import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {catchError, Observable} from "rxjs";
import { environment } from 'src/environments/environment';
import {StateModel} from "../models/state.model";
import {EventsManager} from "../events/events.manager";

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(private http: HttpClient, private em: EventsManager) { }

  getFaqs(): Observable<any>{
    return this.http.get('data/faqs.json').pipe(
      catchError((e) => {
        return e;
      }),
    );
  }

  getTermsOfUse():Observable<any>{
    return this.http.get(environment.apiUrl+environment.treatmentApi+'files/public-documents/terms-of-use.html').pipe(
      catchError((e) => {
        return e;
      }),
    )
  }

  getPrivacyPolicy():Observable<any>{
    return this.http.get(environment.apiUrl+environment.treatmentApi+'files/public-documents/privacy-policy.html').pipe(
      catchError((e) => {
        return e;
      }),
    )
  }

  getStates():Observable<any>{
    return this.http.get('data/states.json').pipe(
      catchError((e) => {
        return e;
      }),
    )
  }

  setAllowedStates(states:any):any{
    let allowed:StateModel[] = [];
    return allowed = this.em.states.filter(function (s:any) { return (states.includedStates.indexOf(s.abbr) >= 0); }).map(function (a:any) { return a; });
  }
}
